import React from 'react';

const LABELS = {
    'en': {
        filtersTitle: 'Filters',
        collabType: 'Collaboration type',
        date:'Date',
        dateFrom: 'From',
        dateTo: 'To',
        status: 'Current status',
        program: 'Program',
        selectClearAll: 'Select/Clear all',
        name: 'Name',
        partners: 'Partners',
        noWheelResults: 'Visualization not available',
        showingCollaborations: (name) => (
            <>
                Showing collaborations between <b>{name}</b> and <b>other entities</b>
            </>
        ),
        showingCollaborationsResults: (result) => (
            <>
                <b>Collaborations</b> <br/>
                We found {result} results
            </>
        ),
        showAll: 'Show all',
        collaborations: 'Collaborations',
        projectDate: 'Project date',
        startDate: 'Start date',
        endDate: 'End date',
        postulationDate: 'Postulation date',
        submitDate: 'Submitted date',
        resultDate: 'Result date',
        resetAll: 'RESET FILTERS',
        people: 'People involved',
        signOut: 'Sign out',
        signIn: 'Sign in',
        search_placeholder: "   Search by projects, entities or members...",
        public_search_placeholder: "    Search by projects or entities...",
        all_collab_tab: "All collaborations",
        science_tab: "Scientific Collaborations",
        innovation_tab: "Innovation Collaborations",
        screenshot_button: "Screenshot",
        switch_cards_left: "Project cards",
        switch_cards_rigth: "Visual board"
    },
    'es': {
        filtersTitle: 'Filtros',
        collabType: 'Tipo de colaboración',
        date:'Fecha',
        dateFrom: 'Desde',
        dateTo: 'Hasta',
        status: 'Estado actual',
        program: 'Programa',
        selectClearAll: 'Seleccionar todo/ninguno',
        name: 'Nombre',
        partners: 'Participantes',
        noWheelResults: 'Visualización no disponible',
        showingCollaborations: (name) => (
            <>
                Mostrando colaboraciones entre <b>{name}</b> y <b>otras entidades</b>
            </>
        ),
        showingCollaborationsResults: (result) => (
            <>
                <b>Colaboraciones</b> <br/>
                Se han encontrado {result} resultados
            </>
        ),
        showAll: 'Mostrar todo',
        collaborations: 'Colaboraciones',
        projectDate: 'Fechas del proyecto',
        startDate: 'Inicio',
        endDate: 'Término',
        postulationDate: 'Fecha de postulación',
        submitDate: 'Postulación',
        resultDate: 'Resultado',
        resetAll: 'REINICIAR FILTROS',
        people: 'Asociados',
        signOut: 'Cerrar sesión',
        signIn: 'Iniciar sesión',
        search_placeholder: "   Buscar por proyecto, entidad o persona...",
        public_search_placeholder: "    Buscar por proyecto o entidad...",
        all_collab_tab: "Todas las Colaboraciones",
        science_tab: "Colaboraciones Científicas",
        innovation_tab: "Colaboraciones Innovación",
        screenshot_button: "Captura de pantalla",
        switch_cards_left: "Vista de tarjetas",
        switch_cards_rigth: "Representación visual"
    }
};

export function getLabels(language) {
    if (['es', 'en'].includes(language)) {
        return LABELS[language];
    }
    return LABELS['en'];
}
